import React from 'react';
import MapDetailsPage from '../MapDetailsPage';

/**
 * Map Details Page Wrapper
 * Main map view showing all properties
 */
function MapDetailsPageWrapper(props) {
  return <MapDetailsPage {...props} />;
}

export default MapDetailsPageWrapper;
